import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Box, Paper, Button } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 24,
  border: '1px solid #F1F5F9',
  boxShadow: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: '#FFF',
}));

// ----------------------------------------------------------------------

YangaGreeting.propTypes = {
  name: PropTypes.string,
  userType: PropTypes.string,
};

export default function YangaGreeting({ name, userType }) {
  const isAdmin = userType?.toUpperCase() === 'ADMIN';

  return (
    <RootStyle sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: 2 }}>
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 800, fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
          Hello, {name}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, mt: 0.5 }}>
          Your digital wealth center is ready. What would you like to do?
        </Typography>
      </Box>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ width: { xs: '100%', sm: 'auto' }, justifyContent: 'flex-end' }}>
        {isAdmin && (
          <Button 
            component={RouterLink} 
            to="/secure/app" 
            variant="contained" 
            sx={{ borderRadius: '12px', fontWeight: 800, px: 3, flexGrow: { xs: 1, sm: 0 } }}
          >
            Go to Admin Panel
          </Button>
        )}
        <Box sx={{ 
            width: 48, 
            height: 48, 
            borderRadius: 1.5, 
            bgcolor: 'primary.lighter', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: 'primary.main',
            display: { xs: isAdmin ? 'none' : 'flex', sm: 'flex' }
        }}>
          <Iconify icon="eva:flash-outline" width={24} height={24} />
        </Box>
      </Stack>
    </RootStyle>
  );
}
